import { Box } from '@mui/material'
import styled from 'styled-components'

export const InfiniteButtonStyles = styled(Box)`
  display: flex;
  justify-content: center;
  width: 100%;
`
